export default {
    0: [
        //postpaid
        {
            Zona: 1,
            Apel_local: '0,18',
            Apel_ro: '0,18',
            Apel_ue: '0,18',
            Apel_non_ue: '1,49',
            Apel_primit: '0',
            SMS_trimis: '0,05',
            GPRS: '0,20',
        },
        {
            Zona: 2,
            Operator: 'preferat',
            Apel_local: '0,83',
            Apel_ro: '0,83',
            Apel_ue: '1,55',
            Apel_non_ue: '1,55',
            Apel_primit: '0,6',
            SMS_trimis: '0,36',
            GPRS: '3,09',
        },
        {
            Zona: 3,
            Operator: 'preferat',
            Apel_local: '1,01',
            Apel_ro: '1,19',
            Apel_ue: '1,67',
            Apel_non_ue: '1,67',
            Apel_primit: '0,77',
            SMS_trimis: '0,42',
            GPRS: '8,45',
        },
        {
            Zona: 4,
            Operator: 'preferat',
            Apel_local: '1,19',
            Apel_ro: '1,90',
            Apel_ue: '2,38',
            Apel_non_ue: '2,38',
            Apel_primit: '1,01',
            SMS_trimis: '0,48',
            GPRS: '9,52',
        },
        {
            Zona: 5,
            Operator: 'preferat',
            Apel_local: '1,55',
            Apel_ro: '2,56',
            Apel_ue: '2,98',
            Apel_non_ue: '2,98',
            Apel_primit: '1,55',
            SMS_trimis: '0,54',
            GPRS: '10,59',
        },
        {
            Zona: 6,
            Operator: 'preferat',
            Apel_local: '5,95',
            Apel_ro: '5,95',
            Apel_ue: '7,14',
            Apel_non_ue: '3,57',
            Apel_primit: '5,95',
            SMS_trimis: '1,19',
            GPRS: '17,85',
        },
        {
            Zona: 7,
            Operator: 'preferat',
            Apel_local: '5,95',
            Apel_ro: '5,95',
            Apel_ue: '7,14',
            Apel_non_ue: '7,14',
            Apel_primit: '5,95',
            SMS_trimis: '1,19',
            GPRS: '17,85',
        },
        {
            Zona: '-',
            Operator: 'preferat',
            Apel_local: '-',
            Apel_ro: '-',
            Apel_ue: '-',
            Apel_non_ue: '-',
            Apel_primit: '-',
            SMS_trimis: '-',
            GPRS: '-',
        },
        {
            // balcani
            Zona: 'Balcani non-SEE',
            Operator: 'preferat',
            Apel_local: '1,01',
            Apel_ro: '1,01',
            Apel_ue: '1,55',
            Apel_non_ue: '1,55',
            Apel_primit: '0,77',
            SMS_trimis: '0,42',
            GPRS: '0,83',
        },
        {
            Zona: 'Sateliti',
            Operator: 'preferat',
            Apel_local: '5,95',
            Apel_ro: '5,95',
            Apel_ue: '7,14',
            Apel_non_ue: '7,14',
            Apel_primit: '5,95',
            SMS_trimis: '1,19',
            GPRS: '17,85',
        },
        {
            Zona: 'PREPAID',
            Operator: 'preferat',
            Apel_local: '0,06',
            Apel_ro: '0,06',
            Apel_ue: '0,06',
            Apel_non_ue: '1,49',
            Apel_primit: '0,013',
            SMS_trimis: '0,024',
            GPRS: '0,036',
        },
    ],
    // prepaid
    1: [
        {
            Zona: 1,
            Operator: 'preferat',
            Apel_local: '0,18',
            Apel_ro: '0,18',
            Apel_ue: '0,18',
            Apel_non_ue: '1,49',
            Apel_primit: '0',
            SMS_trimis: '0,05',
            GPRS: '0,2',
        },
        {
            Zona: 2,
            Operator: 'preferat',
            Apel_local: '0,5',
            Apel_ro: '0,5',
            Apel_ue: '0,5',
            Apel_non_ue: '1,69',
            Apel_primit: '0,5',
            SMS_trimis: '0,35',
            GPRS: '0,05',
        },
        {
            Zona: 3,
            Operator: 'preferat',
            Apel_local: '0,89',
            Apel_ro: '1,69',
            Apel_ue: '2,09',
            Apel_non_ue: '2,09',
            Apel_primit: '0,89',
            SMS_trimis: '0,45',
            GPRS: '8',
        },
        {
            Zona: 4,
            Operator: 'preferat',
            Apel_local: '0,89',
            Apel_ro: '2,29',
            Apel_ue: '2,69',
            Apel_non_ue: '2,69',
            Apel_primit: '1,39',
            SMS_trimis: '0,45',
            GPRS: '8',
        },
        {
            Zona: 5,
            Operator: 'preferat',
            Apel_local: '0,89',
            Apel_ro: '2,49',
            Apel_ue: '2,89',
            Apel_non_ue: '2,89',
            Apel_primit: '0,89',
            SMS_trimis: '0,45',
            GPRS: '8',
        },
        {
            Zona: '-',
            Operator: 'preferat',
            Apel_local: '-',
            Apel_ro: '-',
            Apel_ue: '-',
            Apel_non_ue: '-',
            Apel_primit: '-',
            SMS_trimis: '-',
            GPRS: '-',
        },
        {
            Zona: 'Sateliti acoperire maritimă, acoperire în avion, sateliți tereștri',
            Operator: 'preferat',
            Apel_local: '-',
            Apel_ro: '-',
            Apel_ue: '-',
            Apel_non_ue: '-',
            Apel_primit: '-',
            SMS_trimis: '-',
            GPRS: '-',
        },
    ],
    // internet
    2: [
        {
            Zona: 1,
            Operator: 'preferat',
            Apel_local: '0,18',
            Apel_ro: '0,18',
            Apel_ue: '0,18',
            Apel_non_ue: '1,49',
            Apel_primit: '0',
            SMS_trimis: '0,05',
            GPRS: '0,20',
        },
        {
            Zona: 2,
            Operator: 'preferat',
            Apel_local: '0,89',
            Apel_ro: '1,19',
            Apel_ue: '1,69',
            Apel_non_ue: '1,69',
            Apel_primit: '0,59',
            SMS_trimis: '0,35',
            GPRS: '3,09',
        },
        {
            Zona: 3,
            Operator: 'preferat',
            Apel_local: '0,89',
            Apel_ro: '1,69',
            Apel_ue: '2,09',
            Apel_non_ue: '2,09',
            Apel_primit: '0,59',
            SMS_trimis: '0,35',
            GPRS: '8,45',
        },
        {
            Zona: 4,
            Operator: 'preferat',
            Apel_local: '0,89',
            Apel_ro: '2,29',
            Apel_ue: '2,69',
            Apel_non_ue: '2,69',
            Apel_primit: '1,39',
            SMS_trimis: '0,45',
            GPRS: '9,52',
        },
        {
            Zona: 5,
            Operator: 'preferat',
            Apel_local: '0,89',
            Apel_ro: '2,49',
            Apel_ue: '2,89',
            Apel_non_ue: '2,89',
            Apel_primit: '0,89',
            SMS_trimis: '0,45',
            GPRS: '10,6',
        },
        {
            Zona: 6,
            Operator: 'preferat',
            Apel_local: '5,95',
            Apel_ro: '5,95',
            Apel_ue: '7,14',
            Apel_non_ue: '7,14',
            Apel_primit: '5,95',
            SMS_trimis: '1,19',
            GPRS: '17,85',
        },
        {
            Zona: 7,
            Operator: 'preferat',
            Apel_local: '1,01',
            Apel_ro: '1,01',
            Apel_ue: '1,55',
            Apel_non_ue: '1,55',
            Apel_primit: '0,77',
            SMS_trimis: '0,42',
            GPRS: '0,83',
        },
        {
            Zona: '-',
            Operator: 'preferat',
            Apel_local: '-',
            Apel_ro: '-',
            Apel_ue: '-',
            Apel_non_ue: '-',
            Apel_primit: '-',
            SMS_trimis: '-',
            GPRS: '-',
        },
        {
            Zona: 'Sateliti acoperire maritimă, acoperire în avion, sateliți tereștri',
            Operator: 'preferat',
            Apel_local: '-',
            Apel_ro: '-',
            Apel_ue: '-',
            Apel_non_ue: '-',
            Apel_primit: '-',
            SMS_trimis: '-',
            GPRS: '-',
        },
    ],
};
